import { Component, computed, OnInit, signal } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { TuiButton, TuiLoader, TuiNotification } from '@taiga-ui/core';
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';
import { DialogBase } from '../dialog-base/dialog-base.component';

@Component({
	imports: [
		ImageCropperComponent,
		TuiButton,
		TranslocoModule,
		TuiLoader,
		TuiNotification,
	],
	selector: 'ctx-image-cropper-dialog',
	styleUrl: 'image-cropper-dialog.component.scss',
	templateUrl: 'image-cropper-dialog.component.html',
})
export class ImageCropperDialogComponent
	extends DialogBase<File | null, { imageFile?: File; aspectRatio?: number }>
	implements OnInit
{
	static override readonly DialogOptions = { label: 'media.file-image' };

	readonly croppedImage = signal<File | null>(null);

	readonly cropperLoading = signal(true);
	readonly imageLoading = signal(true);
	readonly loading = signal(true);

	/**
	 * `true` if there was an error loading the image cropper
	 */
	readonly error = signal(false);

	readonly aspectRatio = computed(() => {
		if (!this.context.data.aspectRatio) return 1 / 1;
		return this.context.data.aspectRatio;
	});

	ngOnInit() {
		if (!this.context.data.imageFile) {
			this.onDismiss();
		}
	}

	onImageCropped(event: ImageCroppedEvent) {
		if (!event.blob || !this.context.data.imageFile) return;
		this.croppedImage.set(
			new File([event.blob], this.context.data.imageFile.name, {
				type: this.context.data.imageFile.type,
			}),
		);
	}

	onImageLoaded() {
		this.imageLoading.set(false);
		this.determineLoadState();
	}

	onCropperReady() {
		this.cropperLoading.set(false);
		this.determineLoadState();
	}

	onLoadImageFailed() {
		this.error.set(true);
		this.imageLoading.set(false);
		this.cropperLoading.set(false);
		this.determineLoadState();
	}

	determineLoadState() {
		this.loading.set(this.cropperLoading() || this.imageLoading());
	}

	readonly onSave = () => this.onDismiss(this.croppedImage());
}
